import React, { useEffect, useState } from 'react';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { NAV_LINKS } from '../mock';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_solar-minimal-clean/artifacts/19o67k2a_IMG_6800.jpeg';

const Logo = () => (
  <div className="flex items-center gap-2.5 min-w-0">
    <div className="relative w-11 h-11 rounded-xl overflow-hidden bg-white border border-black/5 shadow-[0_4px_14px_-4px_rgba(30,108,176,0.3)] flex items-center justify-center flex-shrink-0">
      <img src={LOGO_URL} alt="B-WEB" className="w-[88%] h-[88%] object-contain" />
    </div>
    <div className="flex flex-col leading-tight min-w-0">
      <span className="font-display text-[16px] sm:text-[17px] font-extrabold text-neutral-900 tracking-tight">B-WEB</span>
      <span className="text-[9px] sm:text-[9.5px] tracking-[0.16em] sm:tracking-[0.18em] uppercase font-semibold text-neutral-500 truncate">Studio Biella Web</span>
    </div>
  </div>
);

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'py-3' : 'py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div
          className={`flex items-center justify-between rounded-full border border-black/5 backdrop-blur-md transition-all duration-300 ${
            scrolled ? 'bg-white/85 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.15)] px-4 py-2' : 'bg-white/60 px-5 py-3'
          }`}
        >
          <div className="flex items-center gap-6">
            <button onClick={() => handleClick('#top')} className="flex items-center gap-2">
              <Logo />
            </button>
            <nav className="hidden md:flex items-center gap-7 ml-2">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.href}
                  onClick={() => handleClick(l.href)}
                  className="text-[15px] text-neutral-700 hover:text-[#1e6cb0] transition-colors font-medium"
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-2">
            <a
              href="https://wa.me/393383463712?text=Ciao!%20Ho%20visto%20il%20tuo%20sito%20B-WEB%20e%20vorrei%20avere%20informazioni."
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:inline-flex items-center gap-1.5 bg-[#1e6cb0] text-white px-5 py-2.5 rounded-full font-semibold text-[15px] btn-glow"
            >
              Scrivimi <ArrowUpRight className="w-4 h-4" />
            </a>
            <button
              onClick={() => setOpen(!open)}
              className="md:hidden w-10 h-10 rounded-full bg-white border border-black/10 flex items-center justify-center"
              aria-label="menu"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden mt-2 bg-white rounded-2xl border border-black/5 shadow-lg p-4 space-y-2 fade-in-up">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => handleClick(l.href)}
                className="block w-full text-left px-3 py-2.5 rounded-xl hover:bg-neutral-100 text-neutral-800 font-medium"
              >
                {l.label}
              </button>
            ))}
            <a
              href="https://wa.me/393383463712?text=Ciao!%20Ho%20visto%20il%20tuo%20sito%20B-WEB%20e%20vorrei%20avere%20informazioni."
              target="_blank"
              rel="noopener noreferrer"
              className="w-full inline-flex items-center justify-center gap-1.5 bg-[#1e6cb0] text-white px-5 py-3 rounded-xl font-semibold"
            >
              Scrivimi su WhatsApp <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
